// InterAwards.js
import "./css/mycss.css";
import { Cards } from "./Cards.js";
import img1 from "./images/i1.png";
import img2 from "./images/i2.png";
import img3 from "./images/i3.png";
import img4 from "./images/i4.png";
import img5 from "./images/i5.png";

export const internationalAwardsData = [
  {
    category: "International",
    htext: "Jawaharlal Nehru Award",
    ptext: "Award for promotion of international understanding, goodwill and friendship among people worldwide.",
    img1: img1,
    ialt: "Jawaharlal Nehru Award",
    modalContent: `
      <b>Established:</b>1965</br>
      <b>Type:</b>International Civilian Award (Government of India)<br/>
      <b>First Awarded:</b>1965</br>
      <b>First Recipient: </b>U Thant</br>
      <b>Symbolism:</b>Represents India’s vision of global unity, peace and cultural diplomacy.</br>
      <b>Awarded For:</b>Outstanding contribution to international understanding, goodwill and friendship among peoples of the world.</br> 
      <br/><b><a href='https://en.wikipedia.org/wiki/Jawaharlal_Nehru_Award'>wiki link</a></b> 
    `
  },
  {
    category: "International",
    htext: "Gandhi Peace Prize",
    ptext: "International award for contributions to social, economic and political transformation through non-violence and Gandhian ideals.",
    img1: img2,
    ialt: "Gandhi Peace Prize",
    modalContent: `
      <b>Established:</b>1995</br>
      <b>Type:</b>International Prize (Government of India)<br/>
      <b>First Awarded:</b>1995</br>
      <b>First Recipient: </b>Julius Nyerere (former President of Tanzania)</br>
      <b>Symbolism:</b>Embodies non-violence, peace, humanity and social harmony.</br>
      <b>Awarded For:</b>Transformative contribution towards social, political or economic change.</br> 
      <br/><b><a href='https://en.wikipedia.org/wiki/Gandhi_Peace_Prize'>wiki link</a></b> 
    `
  },
  {
    category: "International",
    htext: "Indira Gandhi Prize",
    ptext: "International prize for contributions to peace, disarmament, development and human welfare.",
    img1: img3,
    ialt: "Indira Gandhi Prize",
    modalContent: `
      <b>Established:</b>1986</br>
      <b>Type:</b>International Award<br/>
      <b>First Awarded:</b>1986</br>
      <b>First Recipient: </b>Parliamentarians for Global Action</br>
      <b>Symbolism:</b>Reflects values of peace, development and cooperation.</br>
      <b>Awarded For:</b>International peace, development and humanitarian progress.</br> 
      <br/><b><a href='https://en.wikipedia.org/wiki/Indira_Gandhi_Prize'>wiki link</a></b> 
    `
  },
  {
    category: "International",
    htext: "Tagore Award",
    ptext: "Award honoring contributions to cultural harmony and universal values.",
    img1: img4,
    ialt: "Tagore Award",
    modalContent: `
      <b>Established:</b>2011</br>
      <b>Type:</b>Cultural International Award<br/>
      <b>First Awarded:</b>2012</br>
      <b>First Recipient: </b>Ravi Shankar</br>
      <b>Symbolism:</b>Celebrates harmony, unity and cultural exchange.</br>
      <b>Awarded For:</b>Promoting universal values & cultural harmony.</br> 
      <br/><b><a href='https://en.wikipedia.org/wiki/Tagore_Award'>wiki link</a></b> 
    `
  },
  {
    category: "International",
    htext: "Jamnalal Bajaj Award",
    ptext: "Award promoting Gandhian values, social development and humanitarian work globally.",
    img1: img5,
    ialt: "Jamnalal Bajaj Award",
    modalContent: `
      <b>Established:</b>1978</br>
      <b>Type:</b>Annual International Award<br/>
      <b>First Awarded:</b>1978</br>
      <b>First Recipient: </b>Pierre Parodi</br>
      <b>Symbolism:</b>Supports Gandhian values & global social welfare.</br>
      <b>Awarded For:</b>Social development, humanitarian & rural upliftment.</br> 
      <br/><b><a href='https://en.wikipedia.org/wiki/Jamnalal_Bajaj_Award'>wiki link</a></b> 
    `
  }
];

// Component View
export default function InterAwards() {
  return (
    <div>
      <h1 className="heading">International Awards</h1>
      <h3 className="head2">“Honoring outstanding talent that inspires the world.”</h3>

      <div className="search-cards-container">
        {internationalAwardsData.map((award, index) => (
          <Cards
            key={index}
            htext={award.htext}
            ptext={award.ptext}
            img1={award.img1}
            ialt={award.ialt}
            btext="Learn more"
            modalContent={award.modalContent}
          />
        ))}
      </div>
    </div>
  );
}
